import React from 'react';

const Tools = () => {
    return (
        <div>
           <div className="container">
               <div className="row">
                   <div className="col-md-6">
                        <ul>
                            <li className='title1'><h3 className='text-white '>GitHub</h3></li>
                            <li className='title1'><h3 className='text-white '>VS Code</h3></li>
                            <li className='title1'><h3 className='text-white '>Chorem Dev Tools</h3></li>
                            <li className='title1'><h3 className='text-white '>HeroKu</h3></li>
                            

                        </ul>
                   </div>
                   <div className="col-md-6">
                        <ul>
                            <li className='title1'><h3 className='text-white '>Netlify</h3></li>
                            <li className='title1'><h3 className='text-white '>Firebase</h3></li>
                            <li className='title1'><h3 className='text-white '>Postman</h3></li>
                            <li className='title1'><h3 className='text-white '>Figma</h3></li>
                           

                        </ul>
                   </div>
               </div>
           </div>
        </div>
    );
};

export default Tools;